import Vue from "vue";
import axios from "axios";
import store from "@/store";
import notification from "ant-design-vue/es/notification";
import {
  ACCESS_TOKEN,
  ACCOUNT_TYPE,
  ACCOUNT_TYPE_INFO
} from "../store/mutaion-types.js";

//全局配置
const UNIFY_REQUEST = axios;
UNIFY_REQUEST.defaults.timeout = 30000; //设置30秒

//错误返回
const err = error => {
  if (error.response) {
    const data = error.response.data;
    const token = Vue.ls.get(ACCESS_TOKEN);
    if (error.response.status === 403) {
      notification.error({
        message: "Forbidden",
        description: data.message
      });
    }
    if (
      error.response.status === 401 &&
      !(data.result && data.result.isLogin)
    ) {
      notification.error({
        message: "Unauthorized",
        description: "Authorization verification failed"
      });
      if (token) {
        store.dispatch("Logout").then(() => {
          setTimeout(() => {
            window.location.reload();
          }, 1500);
        });
      }
    }
  }
  return Promise.reject(error);
};

//请求拦截器
UNIFY_REQUEST.interceptors.request.use(config => {
  const token = Vue.ls.get(ACCESS_TOKEN);
  const type = Vue.ls.get(ACCOUNT_TYPE);
  config.headers["User-Account-Type"] = type; // 用户账户类型
  if (token) {
    config.headers["Authorization"] = token; // 让每个请求携带自定义 token 请根据实际情况自行修改
  }
  return config;
}, err);

//响应拦截器
UNIFY_REQUEST.interceptors.response.use(response => {
  const result = response.data;
  if (Object.prototype.hasOwnProperty.call(result, "result")) {
    if (result.result == 0) {
      return result;
    } else {
      if (result.result == 100000 || result.result == 100001) {
        Vue.ls.remove(ACCESS_TOKEN);
        //跳转登录页面
        let accountType = Vue.ls.get(ACCOUNT_TYPE);
        let toPath = "/front/user";
        if (accountType == ACCOUNT_TYPE_INFO.SYSTEM) {
          toPath = "/front/admin";
        }
        window.location.href = toPath;
      } else {
        notification.error({
          message: "提示",
          description: result.msg,
          duration: 5
        });
        return false;
      }
    }
  } else {
    return response;
  }
}, err);

//封装请求
const request = {
  //post 请求
  postForm(url, params) {
    return UNIFY_REQUEST.post(url, params, {
      transformRequest: [
        params => {
          let result = "";
          Object.keys(params).forEach(key => {
            if (
              !Object.is(params[key], undefined) &&
              !Object.is(params[key], null)
            ) {
              result +=
                encodeURIComponent(key) +
                "=" +
                encodeURIComponent(params[key]) +
                "&";
            }
          });
          return result;
        }
      ],
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
      }
    });
  },
  //post 请求
  post(url, params) {
    return UNIFY_REQUEST.post(url, params, {
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      }
    });
  },
  //put 请求
  put(url, params) {
    return UNIFY_REQUEST.put(url, params, {
      // `transformRequest` 允许在向服务器发送前，修改请求数据，只能用在 'PUT', 'POST' 和 'PATCH' 这几个请求方法
      transformRequest: [
        params => {
          let result = "";
          Object.keys(params).forEach(key => {
            if (
              !Object.is(params[key], undefined) &&
              !Object.is(params[key], null)
            ) {
              result +=
                encodeURIComponent(key) +
                "=" +
                encodeURIComponent(params[key]) +
                "&";
            }
          });
          return result;
        }
      ],
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
      }
    });
  },
  //get请求
  get(url, params) {
    let _params;
    if (Object.is(params, undefined)) {
      _params = "";
    } else {
      _params = "?";
      for (let key in params) {
        if (params[key] !== null) {
          _params += `${key}=${params[key]}&`;
        }
      }
    }
    return UNIFY_REQUEST.get(`${url}${_params}`);
  },
  //delete请求
  delete(url, params) {
    let _params;
    if (Object.is(params, undefined)) {
      _params = "";
    } else {
      _params = "?";
      for (let key in params) {
        if (params[key] !== null) {
          _params += `${key}=${params[key]}&`;
        }
      }
    }
    return UNIFY_REQUEST.delete(`${url}${_params}`);
  },
  //导出
  export(url, fileName, params = {}) {
    return UNIFY_REQUEST.post(url, params, {
      transformRequest: [
        params => {
          let result = "";
          Object.keys(params).forEach(key => {
            if (
              !Object.is(params[key], undefined) &&
              !Object.is(params[key], null)
            ) {
              result +=
                encodeURIComponent(key) +
                "=" +
                encodeURIComponent(params[key]) +
                "&";
            }
          });
          return result;
        }
      ],
      responseType: "blob"
    })
      .then(r => {
        const content = r.data;
        const blob = new Blob([content]);
        if ("download" in document.createElement("a")) {
          const elink = document.createElement("a");
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href);
          document.body.removeChild(elink);
        } else {
          navigator.msSaveBlob(blob, fileName);
        }
      })
      .catch(r => {
        console.error(r);
        // message.error("导出失败");
      });
  },
  //下载
  download(url, params, filename) {
    // message.loading("文件传输中");
    return UNIFY_REQUEST.post(url, params, {
      transformRequest: [
        params => {
          let result = "";
          Object.keys(params).forEach(key => {
            if (
              !Object.is(params[key], undefined) &&
              !Object.is(params[key], null)
            ) {
              result +=
                encodeURIComponent(key) +
                "=" +
                encodeURIComponent(params[key]) +
                "&";
            }
          });
          return result;
        }
      ],
      responseType: "blob"
    })
      .then(r => {
        const content = r.data;
        const blob = new Blob([content]);
        if ("download" in document.createElement("a")) {
          const elink = document.createElement("a");
          elink.download = filename;
          elink.style.display = "none";
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href);
          document.body.removeChild(elink);
        } else {
          navigator.msSaveBlob(blob, filename);
        }
      })
      .catch(r => {
        console.error(r);
        // message.error("下载失败");
      });
  },
  //上传
  upload(url, params) {
    return UNIFY_REQUEST.post(url, params, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  },
  blobToBase64(blob) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob); // 核心操作‌:ml-citation{ref="2,5" data="citationList"}
      reader.onload = () => resolve(reader.result); // 含 MIME 头的完整 Base64 字符串‌:ml-citation{ref="4,6" data="citationList"}
      reader.onerror = error => reject(error); // 错误捕获‌:ml-citation{ref="2,5" data="citationList"}
    });
  },
    //验证码
  captcha(url) {
    return new Promise(resolve => {
      UNIFY_REQUEST.get(url, {
        responseType: "blob"
      }).then(r => {
        const content = r.data;
        this.blobToBase64(content).then(base64 => {
          resolve(base64);
        }); // 输出格式：data:image/png;base64,xxxxx‌:ml-citation{ref="3,6" data="citationList"}
      })
    });
  }
};

export default request;
